class BuildYourOwn extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.bundle_type = this.dataset.bundleType;

    this.data = {};
    this.bundle = [];
    this.page = 0;

    this.navigation = this.querySelectorAll('[data-navigation]');
    this.bundle_form = this.querySelector('.bundle__form');
    this.back = this.querySelector('.bundle-navigation__back');
    this.reset = this.querySelectorAll('.bundle-navigation__reset');
    this.type = this.querySelector('.bundle-navigation__step--type');
    this.count = this.querySelector('.bundle-navigation__step--count');

    this.submitForm = this.querySelector('product-form');

    this.heading = this.querySelector('.bundle-navigation__title');
    this.buildTitle = this.dataset.title;
    this.reviewTitle = this.dataset.reviewTitle;

    this.groups = this.querySelectorAll('bundle-group');
    this.upsell = this.querySelector('bundle-upsell');
    this.gifts = this.querySelectorAll('[data-gift]');

    this.back.addEventListener('click', this.prevPage.bind(this));

    this.reset.forEach((reset) => {
      reset.addEventListener('click', this.clear.bind(this));
    });
  }

  getProductForm() {
    var full = true;
    var random = Math.floor(Math.random() * 1000000000);
    var products = [];

    this.bundle.forEach((item, index) => {
      if (item == -1) {
        full = false;
        return;
      }

      var variant = item.variants[0];

      if (item.variants.length > 1) {
        item.variants.forEach((v) => {
          if (v.option1 == '500 mL') {
            variant = v;
          }
        });
      }

      products.push({
        id: variant.id,
        quantity: 1,
        properties: {
          _gui: random,
          _bundleSize: this.bundle.length + this.gifts.length,
          _bundleType: this.bundle_type,
        },
      });
    });

    if (!full) {
      this.nextPage();
      return;
    }

    this.gifts.forEach((gift) => {
      products.push({
        id: parseInt(gift.dataset.gift),
        quantity: 1,
        properties: {
          _gui: random,
          _bundleGift: 'TRUE',
          _bundleSize: this.bundle.length + this.gifts.length,
          _bundleType: this.bundle_type,
        },
      });
    });

    fetch(
      `/products/${this.bundle[0].handle}?section_id=query-product-form&variant=${products[0].id}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const ProductForm = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('product-form');

        ProductForm.dataset.bundle = JSON.stringify(products);

        this.bundle_form.innerHTML = '';
        this.bundle_form.appendChild(ProductForm);
      });
  }

  setData(id, data) {
    this.bundle.push(-1);
    this.data[id] = data;
  }

  updateProductData(index, product) {
    let image = this.navigation[index].querySelector(
      '.bundle-navigation__item-image'
    );

    image.style.backgroundImage = `url('${product.featured_image}')`;
    image.classList.add("active");
    //image.innerHTML = `<span class='visually-hidden'>Remove ${product.title} from bundle</span>`;
  }

  removeProductdata(index) {
    let image = this.navigation[index].querySelector(
      '.bundle-navigation__item-image'
    );

    image.style.backgroundImage = `none`;
    image.classList.remove("active");
    //image.innerHTML = ``;
  }

  add(bundle_id, bundle_index, product_index) {
    let product = this.data[bundle_id][product_index];

    this.bundle[bundle_index] = product;

    this.updateProductData(bundle_index, product);
    this.nextPage();
  }

  remove(bundle_index) {
    this.bundle[bundle_index] = -1;

    this.removeProductdata(bundle_index);
    this.nextPage();
  }

  clear() {
    this.bundle.forEach((item, index) => {
      this.bundle[index] = -1;
      this.removeProductdata(index);
    });

    this.page = 0;
    this.nextPage();
  }

  nextPage() {
    var full = true;

    this.bundle.forEach((item, index) => {
      if (item == -1 && full) {
        this.page = index;
        this.dataset.current = index;
        full = false;
      }
    });

    if (full) {
      this.page = this.bundle.length;
    }

    this.count.innerHTML = `${this.page + 1}`;

    if (this.page != 0) {
      this.back.removeAttribute('disabled');
    } else {
      this.back.setAttribute('disabled', 'disabled');
    }

    if (full) {
      this.classList.add('bundle--complete');
      this.dataset.current = this.bundle.length;

      this.heading.innerHTML = this.reviewTitle;

      this.type.innerHTML = 'Bundle';

      this.getProductForm();
    } else {
      this.classList.remove('bundle--complete');

      this.heading.innerHTML = this.buildTitle;

      this.type.innerHTML = `choose your ${this.groups[this.page].dataset.type}`;
    }

    const rect = this.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetPosition = rect.top + scrollTop - 60;
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }

  prevPage() {
    this.remove(this.page - 1);
  }
}

customElements.define('build-your-own', BuildYourOwn);

class BundleGroup extends HTMLElement {
  constructor() {
    super();

    this.id = this.dataset.id;
    this.index = this.dataset.index;

    this.parent = this.closest('build-your-own');

    this.data = JSON.parse(
      this.querySelector(`#BundleProducts-${this.id}`).textContent
    );
    this.parent.setData(this.id, this.data);

    this.buttons = this.querySelectorAll(`.bundle__add`);

    this.buttons.forEach((button) => {
      button.addEventListener('click', this.addProduct.bind(this));
    });
  }

  addProduct(e) {
    let target = e.target;
    let index = target.dataset.index;

    this.parent.add(this.id, this.index, index);
  }
}

customElements.define('bundle-group', BundleGroup);
